/**
 * Salvadoran colón.
 */
export var SVC = {
  code: 'SVC',
  base: 10,
  exponent: 2
};